import React from 'react';
import { Icon, Typography } from '@ui';
import { Col, Row } from 'antd';

const CoverTitle = ({ icon, title, iconSize = '56px', iconColor }) => {
    return (
        <Row gutter={24} align='middle' wrap={false}>
            <Col>
                <Icon size={iconSize} color={iconColor} component={() => icon} />
            </Col>
            <Col>
                <Typography.Title level={2}>{title}</Typography.Title>
            </Col>
        </Row>
    );
};

export default CoverTitle;
